
<template>
    <modal
      name="i9FieldsUpdateModal"
      classes="v-modal-sec"
      :min-width="200"
      :min-height="200"
      :scrollable="true"
      :reset="true"
      width="750px"
      height="auto"
    >
      <div class="v-modal profile_details_modal error-modal-space">
        <div class="popup-header fromDetailsPage">
          <h2 class="popup-title">I-94 Fields</h2>
          <span  @click="hideMe()">
            <em class="material-icons">close</em>
          </span>
        </div>
        <form @submit.prevent data-vv-scope="i9fieldsUpdateForm">
          <div class="form-container">
            <div class="vx-row" @click="errorMsg = ''">
                <immiInput @input="I94ValueCheck(i94Obj.I94)"  :allowUpperCase="true" :display="false" :fieldsArray="[]" datatype="alpha_num|max:15" cid="benfpassportNumber" formscope="i9fieldsUpdateForm" v-model="i94Obj.I94"  :fieldName="'I94'"  :required="true" label="I-94 Number" placeHolder="I-94 Number" />
                <div class="vs-col w-1/2 ds_check" v-if="checkProperty(i94Obj,'I94')">
                    <div class="form_group custom-form-label custom-cx-box">
                    <vs-checkbox v-model="i94Obj.isI94DSExpiryDate" :fieldName="'isI94DSExpiryDate'"  data-vv-as="consularProcessing"  name="isI94DSExpiryDate" @input="clearI94Field"
                        >Check here if D/S
                        </vs-checkbox>
                    </div>
                </div>
                
               <datepickerField :wrapclass="'md:w-1/2'" :display="false" :notRequired="i94Obj.isI94DSExpiryDate" :isDisabled="(i94Obj.isI94DSExpiryDate && i94Obj.I94) || !i94Obj.I94" :fieldsArray="[]" :validationRequired="true" v-model="i94Obj.I94ExpiryDate"  :fieldName="'I94ExpiryDate'"  formscope="i9fieldsUpdateForm" :dateEnableFrom="new Date()"  label="I-94 Expiry Date" />
               <casedocumentslist :docslist="docsList"  :docMainCategory="'bendocslist'"
                :petition="petition" formscope="i9fieldsUpdateForm" :fieldsArray="[]" 
                v-model="documents" :fieldName="''" :showTitle="false" ></casedocumentslist>
            </div>
            <!--  -->
            <div v-show="errorMsg">
              <vs-alert color="warning" class="warning-alert reg-warning-alert no-border-radius"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
                >{{ errorMsg }}</vs-alert>
            </div>
          </div>
          <div class="popup-footer relative">
            <span class="loader" v-if="loading" ><img src="@/assets/images/main/loader.gif"/></span>
  
            <vs-button color="dark"  @click="hideMe()"  class="cancel" type="filled">Cancel</vs-button>
            <vs-button  color="success"  :disabled="loading"  @click="submitForm()" class="save" type="filled">Update </vs-button>
          </div>        
        </form>
      </div>
    </modal>
  </template>
  <script>
  import datepickerField from "@/views/forms/fields/datepicker.vue";
  import selectField from "@/views/forms/fields/simpleselect.vue";
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import moment from "moment";
  //import FileUpload from "vue-upload-component/src";
  import { EyeIcon } from 'vue-feather-icons'
  import docType from "@/views/common/docType.vue"
  import fileUploadNote from "@/views/common/fileUploadNote.vue";
  import FileUpload from "@/views/FileUpload.vue";
  import casedocumentslist from "@/views/common/casedocuments.vue";
  export default {
    provide() {
        return {
            parentValidator: this.$validator,
        };
    },
    components: {
        datepickerField,
        selectField,
        immiInput,
        docType,
        EyeIcon,
        FileUpload,
        fileUploadNote,
        casedocumentslist
    },
    methods: {
        init(){
            if(this.updateAction === 'I94_BENEFICIARY'){
                let docList=[
                    {
                        required: true,
                        key: 'mostRecentI94',
                        fieldName: 'mostRecentI94',
                        label: 'Most recent I-94'
                    },
                    {
                        key: 'docs_formI94',
                        fileUploading:false,
                        fieldName: 'formI94',
                        required: true,
                        label: 'Copy of I-94'
                    },
                    {
                        required: true,
                        fileUploading:false,
                        key: "slgI94",
                        fieldName: 'slgI94',
                        label: "I-94"
                    },
                ];
                this.docsList = _.cloneDeep(docList);
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'I94')){
                    this.i94Obj['I94'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'I94')
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'isI94DSExpiryDate')){
                    this.i94Obj['isI94DSExpiryDate'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'isI94DSExpiryDate')
                }
                if(this.checkProperty(this.petition,'beneficiaryInfo' ,'I94ExpiryDate')){
                    this.i94Obj['I94ExpiryDate'] = this.checkProperty(this.petition,'beneficiaryInfo' ,'I94ExpiryDate')
                }
                if(this.checkProperty(this.petition,'documents' ,'slgI94')){
                    this.documents['slgI94'] = this.checkProperty(this.petition,'documents' ,'slgI94')
                }
                if(this.checkProperty(this.petition,'documents' ,'formI94')){
                    this.documents['formI94'] = this.checkProperty(this.petition,'documents' ,'formI94')
                }
                if(this.checkProperty(this.petition,'documents' ,'mostRecentI94')){
                    this.documents['mostRecentI94'] = this.checkProperty(this.petition,'documents' ,'mostRecentI94')
                }
            }
            if(this.updateAction === 'I94_SPOUSE'){
                let docList = [
                    {
                        required: true,
                        fileUploading:false,
                        key: "slgI94",
                        fieldName: 'slgI94',
                        label: "I-94"
                    },
                    {
                        required: true,
                        key: 'mostRecentI94',
                        fieldName: 'mostRecentI94',
                        label: 'Most recent I-94'
                    },
                ];
                this.docsList = _.cloneDeep(docList);
                if(this.checkProperty(this.petition, 'dependentsInfo') && this.checkProperty(this.petition, 'dependentsInfo', 'spouse')){
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'I94')){
                        this.i94Obj['I94'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'I94')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'isI94DSExpiryDate')){
                        this.i94Obj['isI94DSExpiryDate'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'isI94DSExpiryDate')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'I94ExpiryDate')){
                        this.i94Obj['I94ExpiryDate'] = this.checkProperty(this.petition['dependentsInfo'],'spouse' ,'I94ExpiryDate')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'slgI94')){
                        this.documents['slgI94'] = this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'slgI94')
                    }
                    if(this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'mostRecentI94')){
                        this.documents['mostRecentI94'] = this.checkProperty(this.petition['dependentsInfo']['spouse'],'documents' ,'mostRecentI94')
                    }
                }
               
            }
            if(this.updateAction === 'I94_CHILD'){
                let docList = [
                    {
                        required: true,
                        fileUploading:false,
                        key: "slgI94",
                        fieldName: 'slgI94',
                        label: "I-94"
                    },
                ];
                this.docsList = _.cloneDeep(docList);
            }
        },
        hideMe() {
            this.$emit("hideI94Modal");
            this.$modal.hide("i9FieldsUpdateModal");
        },
        submitForm(){
            this.$validator.validateAll("i9fieldsUpdateForm").then((result) => {
                if(result){
                    let Payload ={
                        caseId:this.checkProperty(this.reminderDetails, 'caseDetails', 'caseId')
                    };
                    if(this.updateAction === 'I94_BENEFICIARY'){
                        Payload = Object.assign(Payload,{'beneficiaryInfo':this.i94Obj});
                        Payload = Object.assign(Payload,{'documents':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'BENEFICIARY'});
                        Payload = Object.assign(Payload,{'action':'I94_BENEFICIARY'});
                    }
                    if(this.updateAction === 'I94_SPOUSE'){
                        Payload = Object.assign(Payload,{'dependentsInfo':{}});
                        Payload = Object.assign(Payload['dependentsInfo'],{'spouse':this.i94Obj});
                        Payload = Object.assign(Payload,{'spouseDocuments':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'SPOUSE'});
                        Payload = Object.assign(Payload,{'action':'I94_SPOUSE'});
                    }
                    if(this.updateAction === 'I94_CHILD'){
                        Payload = Object.assign(Payload,{'dependentsInfo':{}});
                        Payload = Object.assign(Payload['dependentsInfo'],{'children':this.i94Obj});
                        Payload = Object.assign(Payload,{'childDocuments':this.documents});
                        Payload = Object.assign(Payload,{'benfType':'CHILD'});
                        Payload = Object.assign(Payload,{'action':'I94_CHILD'});
                        Payload = Object.assign(Payload,{'childId':''});
                    }
                    let path = '/petition/update-brief-info';
                    this.$store.dispatch('commonAction', {data:Payload, path:path}).then((res)=>{
                        this.hideMe();
                    }).catch((err)=>{
                        this.errorMsg = err
                    })
                }
            })
        },
        clearI94Field(val){
            if(val){
                this.i94Obj.I94ExpiryDate = null;
            }
        },
        I94ValueCheck(val){
            if(!val){
                this.i94Obj.isI94DSExpiryDate = false;
            }
            if(val.length<=0 && this.i94Obj.isI94DSExpiryDate==false){
                this.i94Obj.I94ExpiryDate = null;
            }
        },
    },
    watch: {
      
    },
    mounted() {
        this.init();
        this.$modal.show("i9FieldsUpdateModal");
  
    },
    data: () => ({
        loading:false,
        errorMsg:'',
        i94Obj:{
            I94:null,
            isI94DSExpiryDate:null,
            I94ExpiryDate:null
        },
        docsList:[],
        documents:{
            mostRecentI94:[],
            formI94:[],
            slgI94:[],
        }
    }),
    props: {
        reminderDetails:{
            type: Object,
            default: null,
        },
        reminderId:{
            type: String,
            default: '',
        },
        updateAction:{
            type: String,
            default: '',
        },
        petition: {
            type: Object,
            default: null,
        },
        petitionId:{
            type: String,
            default: '',
        },
    },
  };
  </script>